import { useEffect } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import classNames from "classnames";
import { toast } from "sonner";

import { CCard, CCardBody } from "@coreui/react";

import { nguyenVatLieuApi } from "src/1/apis/nguyen_vat_lieu.api";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { Info } from "./Info";
import Table from "./Table";
import Toolbar from "./Toolbar";

export const initRow = {
  checked: false,
  code: "",
  wareUnit: "",
  wareQ: 1,
  warePrice: 0,
  total: 0,
};

const Form = ({ isEdit = false, control, setValue, onSubmit, isLoading }) => {
  //#region Data
  const store_code = useWatch({ control, name: "store_code" });
  const checked = useWatch({ control, name: "checked" });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "materials",
    keyName: "__id",
  });

  const isMobile = useMobileDevice();
  //#endregion

  //#region Events
  const onAdd = () => {
    append(initRow, { shouldFocus: false });
  };

  const handleSelectMaterialGroup =
    (onChangeCallback) => async (group_code) => {
      onChangeCallback(group_code);
      try {
        const res = await nguyenVatLieuApi.getAllUncheckMaterials({
          store_code,
          group_code,
          date: checked,
        });
        if (res.data.data) {
          replace(
            res.data.data.map((e) => ({
              checked: false,
              code: e?.code,
              wareQ: 1,
              warePrice: e?.warePrice ?? 0,
              wareUnit: e?.wareUnit,
              total: 0,
            })),
          );
        } else {
          toast.error("Không có sẵn NVL cho nhóm này!");
          replace([initRow]);
        }
      } catch (error) {
        toast.error("Không có sẵn NVL cho nhóm này!");
        replace([initRow]);
        console.error(error);
      }
    };
  //#endregion

  useEffect(() => {
    const handlePress = (event) => {
      if (event.key === "Enter") {
        onAdd();
      }
    };
    window.addEventListener("keypress", handlePress);
    return () => window.removeEventListener("keypress", handlePress);
  }, []);

  //#region
  return (
    <>
      {isMobile ? (
        <>
          <CCard className={classNames("toolbar sticky")}>
            <CCardBody>
              <Toolbar
                control={control}
                onAdd={onAdd}
                onSave={onSubmit}
                remove={remove}
                isLoading={isLoading}
              />
            </CCardBody>
          </CCard>
          <CCard>
            <CCardBody>
              <Info
                control={control}
                isEdit={isEdit}
                setValue={setValue}
                handleSelectMaterialGroup={handleSelectMaterialGroup}
              />
            </CCardBody>
          </CCard>
        </>
      ) : (
        <CCard className={classNames("toolbar sticky")}>
          <CCardBody>
            <Toolbar
              control={control}
              onAdd={onAdd}
              onSave={onSubmit}
              remove={remove}
              isLoading={isLoading}
            />
            <Info
              control={control}
              setValue={setValue}
              handleSelectMaterialGroup={handleSelectMaterialGroup}
            />
          </CCardBody>
        </CCard>
      )}

      <Table
        control={control}
        setValue={setValue}
        materials={fields}
        append={append}
        remove={remove}
      />
    </>
  );
  //#endregion
};

export default Form;
